'use client';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import TitleBar from '../layout/TitleBar';
import { GamesOutlined, MoneyRounded, Atm as AtmIcon, AdfScanner } from '@mui/icons-material';

const AssetsPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const assetItems = [
    { 
      key: 'goa', 
      icon: <GamesOutlined sx={{ fontSize: 48, color: 'primary.main' }} />, 
      label: t('goa'), 
      route: '/app/goas' 
    },
    { 
      key: 'trk', 
      icon: <MoneyRounded sx={{ fontSize: 48, color: 'primary.main' }} />, 
      label: t('trk'), 
      route: '/app/trk/assets' 
    },
    { 
      key: 'atm', 
      icon: <AtmIcon sx={{ fontSize: 48, color: 'primary.main' }} />, 
      label: t('atm'), 
      route: '/app/atm/assets' 
    },
    { 
      key: 'ctm', 
      icon: <AdfScanner sx={{ fontSize: 48, color: 'primary.main' }} />, 
      label: t('ctm'), 
      route: '/app/ctm/assets' 
    },
  ];

  const renderAssetCard = (item: typeof assetItems[0]) => (
    <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item.key}>
      <Card
        sx={{
          cursor: 'pointer',
          height: 200,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out',
          '&:hover': {
            boxShadow: 4,
            transform: 'scale(1.05)',
          }
        }}
        onClick={() => navigate(item.route)}
      >
        <CardContent sx={{ textAlign: 'center' }}>
          <Box sx={{ mb: 2 }}>
            {item.icon}
          </Box>
          <Typography variant="h6" fontWeight="bold">
            {item.label}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );

  return (
    <div>
      <TitleBar title={t('Assets')} />
      <Box sx={{ padding: 2 }}>
        <Grid container spacing={2}>
          {assetItems.map(renderAssetCard)}
        </Grid>
      </Box>
    </div>
  );
};

export default AssetsPage;
